import { render, staticRenderFns } from "./IframeModal.vue?vue&type=template&id=0aeb1dd0&scoped=true"
import script from "./IframeModal.vue?vue&type=script&lang=js"
export * from "./IframeModal.vue?vue&type=script&lang=js"
import style0 from "./IframeModal.vue?vue&type=style&index=0&id=0aeb1dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeb1dd0",
  null
  
)

export default component.exports